import { render } from "./about-page.vue?vue&type=template&id=64a65912"
import script from "./about-page.vue?vue&type=script&lang=js"
export * from "./about-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__